import { finallyChildrenRouterModeHandler } from '@utils/utils'

// 篮球联赛
import basketballLeagueRouter from '@router/basketball/league_commonRouter'
// cba
import basketballLeague_CBARouter from '@router/basketball/league_cba'

const {
  BasketballLeagueScheduleIndex,
  BasketballLeagueTeamRankIndex,
  BasketballLeagueScheduleDetailIndex,
  BasketballLeagueScheduleDetailPreMatch,
  BasketballLeagueScheduleDetailHotspots,
  BasketballLeagueScheduleDetailAnalysis,
  BasketballLeagueScheduleDetailStatistics,
  BasketballLeagueTeamIndex,
  BasketballLeagueTeamDetailIndex,
  BasketballLeagueTeamDetailTeamData,
  BasketballLeagueTeamDetailPlayerList,
  BasketballLeagueTeamDetailMatchRecord,
  BasketballLeagueTeamDetailMatchSchedule,
  BasketballLeaguePlayoffsVsMapIndex,
  BasketballLeagueRecordDetailIndex,
  BasketballLeagueRecordDetailDataOverview,
  BasketballLeagueRecordDetailTeamData,
  BasketballLeagueRecordDetailPlayerData,
  BasketballLeagueRecordDetailLineupData,
  BasketballLeaguePlayerIndex,
  BasketballLeaguePlayerDetailIndex,
  BasketballLeaguePlayerDetailSeasonData,
  BasketballLeaguePlayerDetailCareerData,
  BasketballLeaguePlayerDetailMatchRecord,
  BasketballLeagueSportsHallIndex,
  BasketballLeagueBroadcastListIndex,
  BasketballLeagueDataPackagListIndex,
  BasketballLeagueProgramListIndex,
} = basketballLeagueRouter
const { PlatfromBasketballLeagueFullCBA } = basketballLeague_CBARouter

const pathModuleBase = 'platfromBasketballLeagueFull'
const diffCompetitionTypeArr = [
  {
    name: 'CBA',
    pathModule: 'CBA',
    component: PlatfromBasketballLeagueFullCBA,
  }, // 联赛 cba
]

const baseChildren = [
  // pathModule 默认占位是cba
  {
    path: 'schedule', //basketball/league/赛程
    name: 'scheduleIndex', // 最终生成的name是 scheduleIndex_CBA
    component: BasketballLeagueScheduleIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'schedule'],
      requireLogin: false,
      title: '赛程',
    },
  },
  {
    path: 'teamRank', //basketball/league/赛程
    name: 'teamRankIndex',
    component: BasketballLeagueTeamRankIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'teamRank'],
      requireLogin: false,
      title: '球队排名',
    },
  },
  {
    path: 'scheduleDetail', //basketball/league/赛程详情
    redirect: { name: 'scheduleDetailPreMatch' },
    name: 'scheduleDetailIndex',
    component: BasketballLeagueScheduleDetailIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'schedule'],
      requireLogin: false,
    },
    children: [
      {
        path: 'preMatch', //basketball/league/赛程详情-赛前
        name: 'scheduleDetailPreMatch',
        component: BasketballLeagueScheduleDetailPreMatch,
        meta: {
          pathModule: ['basketball', 'CBA', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'analysis', //basketball/league/赛程详情-数据分析
        name: 'scheduleDetailAnalysis',
        component: BasketballLeagueScheduleDetailAnalysis,
        meta: {
          pathModule: ['basketball', 'CBA', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'statistics', //basketball/league/赛程详情-数据统计
        name: 'scheduleDetailStatistics',
        component: BasketballLeagueScheduleDetailStatistics,
        meta: {
          pathModule: ['basketball', 'CBA', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'hotspots', //basketball/league/赛程详情-投篮热区
        name: 'scheduleDetailHotspots',
        component: BasketballLeagueScheduleDetailHotspots,
        meta: {
          pathModule: ['basketball', 'CBA', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
    ],
  },
  {
    path: 'team', //basketball/league/球队
    name: 'teamIndex',
    component: BasketballLeagueTeamIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'team'],
      requireLogin: false,
      title: '球队',
    },
  },
  {
    path: 'teamDetail', //basketball/league/球队详情
    redirect: { name: 'teamDetailPlayerList' },
    name: 'teamDetailIndex',
    component: BasketballLeagueTeamDetailIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'team'],
      requireLogin: false,
    },
    children: [
      {
        path: 'playerList', //basketball/league/球队详情-名单
        name: 'teamDetailPlayerList',
        component: BasketballLeagueTeamDetailPlayerList,
        meta: {
          pathModule: ['basketball', 'CBA', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'teamData', //basketball/league/球队详情-数据
        name: 'teamDetailTeamData',
        component: BasketballLeagueTeamDetailTeamData,
        meta: {
          pathModule: ['basketball', 'CBA', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'matchRecord', //basketball/league/球队详情-比赛统计
        name: 'teamDetailMatchRecord',
        component: BasketballLeagueTeamDetailMatchRecord,
        meta: {
          pathModule: ['basketball', 'CBA', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'matchSchedule', //basketball/league/球队详情-赛程
        name: 'teamDetailMatchSchedule',
        component: BasketballLeagueTeamDetailMatchSchedule,
        meta: {
          pathModule: ['basketball', 'CBA', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
    ],
  },
  {
    path: 'playoffsVsMap', //basketball/league/季后赛对阵
    name: 'playoffsVsMapIndex',
    component: BasketballLeaguePlayoffsVsMapIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'playoffsVsMap'],
      requireLogin: false,
      title: '季后赛对阵',
    },
  },
  {
    path: 'record', //basketball/league/数据中心
    redirect: { name: 'recordDetailDataOverview' },
    name: 'recordDetailIndex',
    component: BasketballLeagueRecordDetailIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'record'],
      requireLogin: false,
    },
    children: [
      {
        path: 'dataOverview', //basketball/league/数据中心-数据概览
        name: 'recordDetailDataOverview',
        component: BasketballLeagueRecordDetailDataOverview,
        meta: {
          pathModule: ['basketball', 'CBA', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'teamData', //basketball/league/数据中心-球队数据
        name: 'recordDetailTeamData',
        component: BasketballLeagueRecordDetailTeamData,
        meta: {
          pathModule: ['basketball', 'CBA', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'playerData', //basketball/league/数据中心-球员数据
        name: 'recordDetailPlayerData',
        component: BasketballLeagueRecordDetailPlayerData,
        meta: {
          pathModule: ['basketball', 'CBA', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'lineupData', //basketball/league/数据中心-阵容数据
        name: 'recordDetailLineupData',
        component: BasketballLeagueRecordDetailLineupData,
        meta: {
          pathModule: ['basketball', 'CBA', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
    ],
  },
  // {
  //   path: 'recordDataOverview', //basketball/league/数据中心-数据概览
  //   name: 'recordDataOverviewIndex',
  //   component: BasketballLeagueRecordDataOverviewIndex,
  //   meta: {
  //     pathModule: ['basketball', 'CBA', 'record'],
  //     requireLogin: false,
  //     title: '数据中心',
  //   },
  // },
  // {
  //   path: 'recordTeamData', //basketball/league/数据中心-球队数据
  //   name: 'recordTeamDataIndex',
  //   component: BasketballLeagueRecordTeamDataIndex,
  //   meta: {
  //     pathModule: ['basketball', 'CBA', 'record'],
  //     requireLogin: false,
  //     title: '数据中心',
  //   },
  // },
  // {
  //   path: 'recordPlayerData', //basketball/league/数据中心-球员数据
  //   name: 'recordPlayerDataIndex',
  //   component: BasketballLeagueRecordPlayerDataIndex,
  //   meta: {
  //     pathModule: ['basketball', 'CBA', 'record'],
  //     requireLogin: false,
  //     title: '数据中心',
  //   },
  // },
  {
    path: 'player', //basketball/league/球员
    name: 'playerIndex',
    component: BasketballLeaguePlayerIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'player'],
      requireLogin: false,
      title: '球员',
    },
  },
  {
    path: 'playerDetail', //basketball/league/球员详情
    redirect: { name: 'playerDetailSeasonData' },
    name: 'playerDetailIndex',
    component: BasketballLeaguePlayerDetailIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'player'],
      requireLogin: false,
    },
    children: [
      {
        path: 'seasonData', //basketball/league/球员详情-综合数据
        name: 'playerDetailSeasonData',
        component: BasketballLeaguePlayerDetailSeasonData,
        meta: {
          pathModule: ['basketball', 'CBA', 'player'],
          requireLogin: false,
          title: '球员详情',
        },
      },
      {
        path: 'careerData', //basketball/league/球员详情-生涯数据
        name: 'playerDetailCareerData',
        component: BasketballLeaguePlayerDetailCareerData,
        meta: {
          pathModule: ['basketball', 'CBA', 'player'],
          requireLogin: false,
          title: '球员详情',
        },
      },
      {
        path: 'matchRecord', //basketball/league/球员详情-比赛统计
        name: 'playerDetailMatchRecord',
        component: BasketballLeaguePlayerDetailMatchRecord,
        meta: {
          pathModule: ['basketball', 'CBA', 'player'],
          requireLogin: false,
          title: '球员详情',
        },
      },
    ],
  },
  {
    path: 'sportsHall', //basketball 联赛-场馆
    name: 'sportsHallIndex',
    component: BasketballLeagueSportsHallIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'sportsHall'],
      requireLogin: false,
      title: '场馆',
    },
  },
  {
    path: 'broadcastList', //basketball 联赛-播出单
    name: 'broadcastListIndex',
    component: BasketballLeagueBroadcastListIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'broadcastList'],
      requireLogin: false,
      title: '播出单',
    },
  },
  {
    path: 'dataPackagList', //basketball 联赛-数据包装
    name: 'dataPackagListIndex',
    component: BasketballLeagueDataPackagListIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'dataPackagList'],
      requireLogin: false,
      title: '数据包装',
    },
  },
  {
    path: 'programList', //节目单
    name: 'programListIndex',
    component: BasketballLeagueProgramListIndex,
    meta: {
      pathModule: ['basketball', 'CBA', 'programList'],
      requireLogin: false,
      title: '节目单',
    },
  },
]

const finallyChildrenRouterModeArr = finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
)

const RouterModeArr = diffCompetitionTypeArr.map((routerItem, routerIndex) => ({
  path: `/${routerItem.pathModule}`, // /CBA
  name: `${pathModuleBase}_${routerItem.name}`, // platfromBasketballLeagueFull_CBA
  component: routerItem.component,
  children: finallyChildrenRouterModeArr[routerIndex],
}))

export default { basketball_CBA_RouterMode: RouterModeArr[0] }
